import React from "react";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const TermsAndConditions = ({ content }) => {
  const { title, description } = content;

  return (
    <div id="termsAndConditions">
      <div className="left">
        <div className="content">
          <h4>{title}</h4>
          <div className="terms" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
